import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { User, Car } from 'lucide-react';

const VEHICLE_TYPES = [
  { value: 'sedan', label: 'Sedán' },
  { value: 'suv', label: 'SUV' },
  { value: 'pickup', label: 'Camioneta / Pickup' },
  { value: 'motocicleta', label: 'Motocicleta' },
  { value: 'otro', label: 'Todo terreno / Otro' },
];

export default function WalkInModal({ open, onOpenChange, onConfirm }) {
  const [form, setForm] = useState({ name: '', vehicle_type: 'sedan', model: '', color: '' });

  useEffect(() => {
    if (open) setForm({ name: '', vehicle_type: 'sedan', model: '', color: '' });
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const name = form.name.trim() || 'Walk-in';
    onConfirm({
      name,
      vehicle_type: form.vehicle_type,
      model: form.model.trim() || null,
      color: form.color.trim() || null,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="walk-in-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <User className="w-5 h-5 text-amber-600" />
            Walk-in (sin registro)
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="walkin-name">Nombre del cliente (opcional)</Label>
            <Input
              id="walkin-name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Ej: Sr. Pérez"
              className="mt-1"
              autoFocus
              data-testid="walkin-name"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="flex items-center gap-1"><Car className="w-3.5 h-3.5" /> Tipo de vehículo *</Label>
              <Select
                value={form.vehicle_type}
                onValueChange={(v) => setForm({ ...form, vehicle_type: v })}
              >
                <SelectTrigger className="mt-1" data-testid="walkin-vehicle-type">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {VEHICLE_TYPES.map((t) => (
                    <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label htmlFor="walkin-color">Color</Label>
              <Input
                id="walkin-color"
                value={form.color}
                onChange={(e) => setForm({ ...form, color: e.target.value })}
                placeholder="Ej: rojo, blanco"
                className="mt-1"
                data-testid="walkin-color"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="walkin-model">Modelo (sin placas)</Label>
            <Input
              id="walkin-model"
              value={form.model}
              onChange={(e) => setForm({ ...form, model: e.target.value })}
              placeholder="Ej: Nissan Versa 2022"
              className="mt-1"
              data-testid="walkin-model"
            />
            <p className="text-xs text-slate-500 mt-1">Marca y modelo del vehículo, sin placas.</p>
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" className="bg-amber-500 hover:bg-amber-600 text-white" data-testid="walkin-confirm-btn">
              Registrar Walk-in
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
